import r from "./index909.js";
import i from "./index969.js";
function f(t, a) {
  var e = i(t, a);
  return r(e) ? e : void 0;
}
export {
  f as default
};
